import renderHtml from './renderHtml';
import richTextOptions from './richTextOptions';

const utils = {
  renderHtml,
  richTextOptions
};

export default utils;
